export default "__VITE_ASSET__DlpC$DT3__"